// Mock data for MERIDIAN luxury watch store (frontend-only teaser, persisted to localStorage)

export const IMG = {
  men: [
    "https://images.unsplash.com/photo-1670177257750-9b47927f68eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1618215650148-e8e61eae521c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1600003014755-ba31aa59c4b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/380782/pexels-photo-380782.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    "https://images.pexels.com/photos/190819/pexels-photo-190819.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    "https://images.unsplash.com/photo-1620625515032-6ed0c1790c75?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1523170335258-f5ed11844a49?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1524805444758-089113d48a6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1542496658-e33a6d0d50f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/33524465/pexels-photo-33524465.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    "https://images.pexels.com/photos/9713527/pexels-photo-9713527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  ],
  women: [
    "https://images.unsplash.com/photo-1751437774882-deeea4352018?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1751437761644-460ae92e34c9?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1703034390224-f5f0a204abc7?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1590736969955-71cc94801759?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1716978502767-1d8244462f3c?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1723328254549-24bb3deb4a83?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1636289141131-389e44e981c0?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1653651460770-73513a4b25a5?auto=format&fit=crop&w=900&q=80",
  ],
  hero: [
    "https://images.unsplash.com/photo-1604840651364-52fe7d985d69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    "https://images.unsplash.com/photo-1610230099906-7ad016cf5cf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    "https://images.unsplash.com/photo-1600003014755-ba31aa59c4b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  ],
  box: [
    "https://images.unsplash.com/photo-1635462684825-3621c1df5403?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1604242692760-2f7b0c26856d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1579811216948-6f57c19376a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1685392024138-36e7aade79f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1628483211662-9bcc692c46dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1637868796504-32f45a96d5a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ],
};

export const defaultSettings = {
  brandName: "MERIDIAN",
  brandSub: "İstanbul",
  logoImage: "", // if set, image overrides text logo
  brandColor: "#800000",
  customBadges: {},
  whatsappNumber: "+90 555 123 45 67",
  whatsappUsername: "meridianwatches", // WhatsApp username (chat without sharing number)
  promoText: {
    tr: "İstanbul içi aynı gün teslimat — 14:00'a kadar verilen siparişlerde ücretsiz kurye.",
    en: "Same-day delivery within Istanbul — free courier for orders placed before 2 PM.",
  },
  heroSlides: [
    {
      id: "h1",
      image: IMG.hero[0],
      title: { tr: "Zamanın Ötesinde", en: "Beyond Time" },
      subtitle: {
        tr: "İsviçre mekanizmalı, ustalık işi koleksiyon",
        en: "Swiss-movement collection crafted with mastery",
      },
      cta: { tr: "Koleksiyonu Keşfet", en: "Discover the Collection" },
      link: "/shop",
    },
    {
      id: "h2",
      image: IMG.hero[1],
      title: { tr: "Yeni Sezon", en: "New Season" },
      subtitle: {
        tr: "2026 kadın koleksiyonu şimdi vitrinde",
        en: "The 2026 women's collection is now available",
      },
      cta: { tr: "Göz Atın", en: "Explore" },
      link: "/shop/bayan-saatler",
    },
  ],
  aboutText: {
    tr: "MERIDIAN, İstanbul'un kalbinde ustalık ve zarafeti bir araya getiren bir saat evidir. Her modelimiz, en ince detayına kadar özenle seçilir ve titizlikle hazırlanır.",
    en: "MERIDIAN is a watch house in the heart of Istanbul, uniting craftsmanship and elegance. Every model is carefully selected and meticulously prepared down to the finest detail.",
  },
  footerText: {
    tr: "Zarafet ve ustalığın buluştuğu adres. İstanbul'un lüks saat evi.",
    en: "Where elegance meets craftsmanship. Istanbul's house of fine watches.",
  },
  social: { instagram: "https://instagram.com", facebook: "https://facebook.com", twitter: "https://twitter.com" },
  contact: {
    address: { tr: "Nişantaşı, İstanbul, Türkiye", en: "Nişantaşı, Istanbul, Türkiye" },
    email: "info@meridian.com",
    phone: "+90 555 123 45 67",
    hours: { tr: "Her gün 10:00 – 20:00", en: "Everyday 10:00 – 20:00" },
  },
};

export const defaultCategories = [
  {
    id: "c1",
    slug: "erkek-saatler",
    name: { tr: "ERKEK SAATLER", en: "MEN'S WATCHES" },
    subcategories: [
      { id: "s1", slug: "chronograph", name: { tr: "Chronograph", en: "Chronograph" } },
      { id: "s2", slug: "dalis", name: { tr: "Dalış", en: "Diver" } },
      { id: "s3", slug: "klasik", name: { tr: "Klasik", en: "Classic" } },
      { id: "s4", slug: "iskelet", name: { tr: "İskelet", en: "Skeleton" } },
    ],
  },
  {
    id: "c2",
    slug: "bayan-saatler",
    name: { tr: "BAYAN SAATLER", en: "WOMEN'S WATCHES" },
    subcategories: [
      { id: "s5", slug: "elmas", name: { tr: "Elmas", en: "Diamond" } },
      { id: "s6", slug: "rose-gold", name: { tr: "Rose Gold", en: "Rose Gold" } },
      { id: "s7", slug: "sedef", name: { tr: "Sedef", en: "Mother of Pearl" } },
    ],
  },
  {
    id: "c3",
    slug: "koleksiyonlar",
    name: { tr: "KOLEKSİYONLAR", en: "COLLECTIONS" },
    subcategories: [
      { id: "s8", slug: "rolex", name: { tr: "Rolex", en: "Rolex" } },
      { id: "s9", slug: "audemars-piguet", name: { tr: "Audemars Piguet", en: "Audemars Piguet" } },
      { id: "s10", slug: "patek-philippe", name: { tr: "Patek Philippe", en: "Patek Philippe" } },
      { id: "s11", slug: "omega", name: { tr: "Omega", en: "Omega" } },
    ],
  },
  {
    id: "c4",
    slug: "aksesuar",
    name: { tr: "AKSESUAR", en: "ACCESSORIES" },
    subcategories: [
      { id: "s12", slug: "saat-kutusu", name: { tr: "Saat Kutusu", en: "Watch Box" } },
      { id: "s13", slug: "deri", name: { tr: "Deri Ürünler", en: "Leather Goods" } },
    ],
  },
];

const reviewsTR = [
  { id: "r1", name: "Mehmet A.", rating: 5, text: "Beklentimin çok üzerinde bir kalite. Kargo da çok hızlıydı." },
  { id: "r2", name: "Elif K.", rating: 5, text: "Kutusu ve işçiliği harika. Kesinlikle tavsiye ederim." },
  { id: "r3", name: "Can T.", rating: 4, text: "Çok şık duruyor, fiyatına göre mükemmel." },
];

let idc = 0;
const uid = () => `p${++idc}`;

const mk = (name, nameEn, price, cat, sub, images, badges, rating, section) => ({
  id: uid(),
  slug: name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, ""),
  name,
  nameEn,
  price,
  category: cat,
  subcategory: sub,
  images,
  description: {
    tr: "İsviçre mekanizması ile üretilen bu model, safir camı ve paslanmaz çelik kasasıyla uzun ömürlü kullanım sunar. Su geçirmezlik ve zarif tasarımı bir arada barındırır.",
    en: "Featuring a Swiss movement, sapphire crystal and stainless steel case, this model offers long-lasting use — combining water resistance with an elegant design.",
  },
  rating,
  badges,
  sku: "MRD-" + String(idc).padStart(4, "0"),
  tags: [nameEn.split(" ")[0], (name.match(/\d+mm/) || ["Klasik"])[0]],
  video: "",
  discount: null, // { type: 'percent'|'flat', value: number }
  specs: {
    brand: nameEn.split(" ")[0],
    movement: { tr: "İsviçre Otomatik", en: "Swiss Automatic" },
    caseMaterial: { tr: "Paslanmaz Çelik", en: "Stainless Steel" },
    diameter: (name.match(/\d+mm/) || ["41mm"])[0],
    glass: { tr: "Safir Cam", en: "Sapphire Crystal" },
    waterResistance: "100m",
    warranty: { tr: "2 Yıl Garanti", en: "2 Year Warranty" },
  },
  reviews: reviewsTR,
  createdAt: Date.now(),
});

export const defaultProducts = [
  mk("Chrono Noir 41mm", "Chrono Noir 41mm", 32000, "erkek-saatler", "chronograph", [IMG.men[0], IMG.men[1]], ["trending"], 4.8, "featured"),
  mk("Aviator GMT Steel", "Aviator GMT Steel", 28500, "erkek-saatler", "chronograph", [IMG.men[1], IMG.men[2]], ["fast_shipping"], 4.7, "featured"),
  mk("Deepsea Diver 300", "Deepsea Diver 300", 36000, "erkek-saatler", "dalis", [IMG.men[5], IMG.men[6]], ["new"], 4.9, "featured"),
  mk("Heritage Classic Gold", "Heritage Classic Gold", 42000, "erkek-saatler", "klasik", [IMG.men[6], IMG.men[7]], ["last_stock"], 5.0, "featured"),
  mk("Skeleton Openwork", "Skeleton Openwork", 47000, "erkek-saatler", "iskelet", [IMG.men[8], IMG.men[9]], ["trending"], 4.6, "featured"),
  mk("Onyx Sport 42mm", "Onyx Sport 42mm", 30500, "erkek-saatler", "dalis", [IMG.men[3], IMG.men[4]], [], 4.5, "featured"),

  mk("Rose Élégance 31mm", "Rose Élégance 31mm", 29000, "bayan-saatler", "rose-gold", [IMG.women[0], IMG.women[3]], ["trending"], 4.9, "women"),
  mk("Diamant Pavé", "Diamant Pavé", 54000, "bayan-saatler", "elmas", [IMG.women[1], IMG.women[2]], ["new"], 5.0, "women"),
  mk("Perle Sedef 28mm", "Perle Sedef 28mm", 26000, "bayan-saatler", "sedef", [IMG.women[6], IMG.women[7]], ["fast_shipping"], 4.7, "women"),
  mk("Étoile Gold", "Étoile Gold", 33500, "bayan-saatler", "rose-gold", [IMG.women[4], IMG.women[5]], ["last_stock"], 4.8, "women"),

  mk("Submariner Tribute", "Submariner Tribute", 37000, "koleksiyonlar", "rolex", [IMG.men[7], IMG.men[5]], ["trending"], 4.9, "collection"),
  mk("Royal Oak Homage", "Royal Oak Homage", 49000, "koleksiyonlar", "audemars-piguet", [IMG.men[2], IMG.men[0]], ["new"], 4.8, "collection"),
  mk("Nautilus Blue", "Nautilus Blue", 52000, "koleksiyonlar", "patek-philippe", [IMG.men[10], IMG.men[8]], [], 4.7, "collection"),
  mk("Seamaster Ocean", "Seamaster Ocean", 34000, "koleksiyonlar", "omega", [IMG.men[4], IMG.men[3]], ["fast_shipping"], 4.6, "collection"),

  mk("Premium Saat Kutusu", "Premium Watch Box", 4500, "aksesuar", "saat-kutusu", [IMG.box[0], IMG.box[1]], ["fast_shipping"], 4.9, "accessory"),
  mk("Deluxe Vitrin Kutu", "Deluxe Display Box", 5500, "aksesuar", "saat-kutusu", [IMG.box[2], IMG.box[0]], [], 4.8, "accessory"),
  mk("Altın Kol Düğmesi", "Gold Cufflinks", 3200, "aksesuar", "deri", [IMG.box[3], IMG.box[4]], ["last_stock"], 4.7, "accessory"),
  mk("Deri Cüzdan Seti", "Leather Wallet Set", 2800, "aksesuar", "deri", [IMG.box[4], IMG.box[5]], [], 4.6, "accessory"),
];

// Demo discounts
defaultProducts[0].discount = { type: "percent", value: 20 };
defaultProducts[6].discount = { type: "flat", value: 4000 };
defaultProducts[10].discount = { type: "percent", value: 15 };
// Demo video
defaultProducts[2].video = "https://www.youtube.com/watch?v=ScMzIvxBSi4";

export const BADGE_TYPES = {
  fast_shipping: { tr: "Hızlı Kargo", en: "Fast Shipping", color: "#0f7b3f" },
  last_stock: { tr: "Son Stok", en: "Last in Stock", color: "#b8860b" },
  trending: { tr: "Trend Ürün", en: "Trending", color: "#800000" },
  new: { tr: "Yeni", en: "New", color: "#1f2937" },
};

// Price computation with discount
export function priceInfo(product) {
  const original = Number(product.price) || 0;
  const d = product.discount;
  if (d && Number(d.value) > 0) {
    let final = d.type === "percent" ? original * (1 - Number(d.value) / 100) : original - Number(d.value);
    final = Math.max(0, Math.round(final));
    const pct = d.type === "percent" ? Math.round(Number(d.value)) : Math.round(((original - final) / original) * 100);
    return { original, final, hasDiscount: final < original, pct };
  }
  return { original, final: original, hasDiscount: false, pct: 0 };
}
